import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { AdvanceNoticeDetailPage } from './AdvanceNoticeDetailPage';
import { AdvanceNoticeFormPage } from './AdvanceNoticeFormPage';
import { AdvanceNoticeListPage } from './AdvanceNoticeListPage';

/** advance-notices（担当: G2）。パスは `/years/:year` からの相対。S-20〜S-22 */
export const routes: RouteObject[] = [
  {
    path: 'advance-notices',
    handle: { crumb: '事前連絡' } satisfies RouteHandle,
    element: <Outlet />,
    children: [
      { index: true, element: <AdvanceNoticeListPage /> },
      {
        path: 'new',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <AdvanceNoticeFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '新規登録' } satisfies RouteHandle,
      },
      { path: ':id', element: <AdvanceNoticeDetailPage />, handle: { crumb: '詳細' } satisfies RouteHandle },
      {
        path: ':id/edit',
        element: (
          <RequireAuth roles={['基金', '漁協']}>
            <AdvanceNoticeFormPage />
          </RequireAuth>
        ),
        handle: { crumb: '変更・中止' } satisfies RouteHandle,
      },
    ],
  },
];
